import { render, staticRenderFns } from "./ReceiptOrderLineItems.vue?vue&type=template&id=99d334d2&"
import script from "./ReceiptOrderLineItems.vue?vue&type=script&lang=js&"
export * from "./ReceiptOrderLineItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VAlert,VDivider})
